<template>
  <main>
    <div>
      <v-container>
        <v-card class="">
          <div class="card-content">
            <img src="/static/svg/communication/writing.svg" style="height: 40px;">
            <span class="card-title" style="vertical-align:top;">
              お問合せ
            </span>
          </div>
          <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSdku7asj-prSaEg0YWi3DPks6ACtATcP1Gmjoow2srjIvoI6w/viewform?embedded=true" width="100%" height="1150" frameborder="0" marginheight="5" marginwidth="10px">読み込んでいます...</iframe>
        </v-card>
      </v-container>
    </div>
  </main>
</template>

<script>
export default {
  name: 'contact',
  head: {
    title: {
      inner: 'お問合せ'
    }
  }
}
</script>


// WEBPACK FOOTER //
// Contact.vue?c3b3ed42